import React from "react";
import styled from "styled-components";
import { divisionsT5 } from "../utils/constants";
import { Link } from "react-router-dom";

const Temp5PlayoffPage = () => {
  return (
    <Wrapper>
      <div>
        <div className="center align-content">
          <Link to="temporada-5">
            <button className="btn space-around">Temporada 5</button>
          </Link>
          <Link to="info-temporada-5">
            <button className="btn space-around">Info T5</button>
          </Link>
        </div>
      </div>

      {divisionsT5.map((division) => {
        if (division.id === 1) return "";
        return (
          <div>
            {division.playoffPromotion ? (
              <article>
                <h2 className="special-title">
                  {division.playoffPromotionName}
                </h2>
                <p>
                  <img
                    src={division.playoffPromotion}
                    alt={division.playoffPromotionName}
                  />
                </p>
              </article>
            ) : (
              ""
            )}
            {division.playoffRelegation ? (
              <article>
                <h2 className="special-title">
                  {division.playoffRelegationName}
                </h2>
                <p>
                  <img
                    src={division.playoffRelegation}
                    alt={division.playoffRelegationName}
                  />
                </p>
              </article>
            ) : (
              ""
            )}
          </div>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }

  .space-around {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
`;
export default Temp5PlayoffPage;
